import { z } from 'zod'

export const billingTopupStatusReadResponseSchema = z.object({}).passthrough()
export type BillingTopupStatusReadResponse = z.infer<typeof billingTopupStatusReadResponseSchema>
